<template>
  <div class="com-table com-address">
    <div class="com-title pr">修改收货地址</div>
    <el-form label-width="100px" :model="formData" :rules="rules" ref="formTable">
      <el-form-item label="地址信息：" prop="add">
        <area-cascader type="text" :level="1" placeholder="请选择省/市/区/街道" :data="pcaa"
                       v-model="formData.add"></area-cascader>
      </el-form-item>
      <el-form-item label="详细地址：" prop="street">
        <el-input v-model="formData.street" placeholder="请输入详细地址信息，如道路，门牌号，小区，楼栋号，单元等信息"></el-input>
      </el-form-item>
      <el-form-item label="邮政编码：" prop="postalCode">
        <el-input v-model="formData.postalCode" placeholder="填写6位邮政编码"></el-input>
      </el-form-item>
      <el-form-item label="收货人：" prop="name">
        <el-input v-model="formData.name" placeholder="输入收货人姓名,长度不超过5个字符"></el-input>
      </el-form-item>
      <el-form-item label="手机号码：" prop="mobile">
        <el-input v-model="formData.mobile" placeholder="输入手机号码，长度为11个数字"></el-input>
      </el-form-item>
      <div class="button">
        <el-button type="primary" @click="submitForm('formTable')">保存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import { pcaa } from 'area-data'
  import Api from '@/api/client/shop-address'

  export default {
    inject: ['reload'],
    props: {
      data: {
        type: Object
      },
      edit: false
    },
    computed: {
      formData () {
        return this.data
      }
    },
    data () {
      return {
        hackReset: false,
        cityShow: false,
        pcaa: pcaa,
        rules: {
          address: [
            {required: true, message: '请选择省/市/区/街道', trigger: ['blur']}
          ],
          street: [
            {required: true, message: '请输入详细地址信息', trigger: ['blur']}
          ],
          postalCode: [{pattern: /^[0-9]{6}$/, message: '格式不正确,请输入6位数字', trigger: ['blur']}],
          name: [
            {required: true, message: '输入收货人姓名', trigger: ['blur']},
            {min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: ['blur']}
          ],
          mobile: [
            {required: true, message: '请输入11位手机号', trigger: ['blur']},
            {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确,请按照手机号输入', trigger: ['blur']}
          ]
        }
      }
    },
    methods: {
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.formData.address = this.formData.add
            Api.putEdit(this.formData.id, {form: this.formData}, response => {
              let status = response.status
              let data = Object.assign({'index': this.formData.index}, response.data)
              if (status >= 200 && status <= 204) {
                this.$emit('edit', data)
                this.$message.success('修改成功！')
              } else {
                this.$message.error('修改失败！')
              }
            })
            this.form = []
            this.formData.add = []
            this.reload()
          } else {
            return false
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .com-address {
    .button {
      padding: 33px 0;
      text-align: center;
    }
  }
</style>
<style lang="scss">
  .com-address {
    .el-input__inner {
      width: 452px;
      height: 32px;
      line-height: 32px;
    }
    .el-form {
      margin-top: 20px;
    }
    .el-form-item {
      margin: 0;
      padding: 10px 0;
    }
    .el-button--primary {
      background: #085ECC;
      padding: 9px 35px;
      outline: none;
      border: none;
    }
    .el-button--text {
      color: #666666;
      font-size: 14px;
    }
    .el-button + .el-button {
      margin: 0;
    }
    .area-select.large {
      width: 452px;
      box-sizing: border-box;
    }
    .area-select {
      line-height: 32px;
    }
    .area-select .area-selected-trigger {
      padding: 0 0 0 15px
    }
    .cascader-menu-list .cascader-menu-option.selected {
      color: #085ecc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/common/EditAddress.vue